export default __webpack_public_path__ + "static/media/slider-cai-4.6e04035c.jpg";